export default {
  settings: {
    zh: '设置',
    en: 'Settings',
    ja: '設定',
  },
  general: {
    zh: '基础',
    en: 'General',
    ja: '一般',
  },
  language: {
    zh: '语言',
    en: 'Language',
    ja: '言語',
  },
  automatically: {
    zh: '自动检查更新',
    en: 'Auto check update',
    ja: '自動更新チェック',
  },
  maxReconnectTimes: {
    zh: '最大重连次数',
    en: 'Max reconnection times',
    ja: '最大再接続回数',
  },
  appearance: {
    zh: '外观',
    en: 'Appearance',
    ja: '外観',
  },
  theme: {
    zh: '主题',
    en: 'Theme',
    ja: 'テーマ',
  },
  light: {
    zh: '浅色',
    en: 'Light',
    ja: 'ライト',
  },
  dark: {
    zh: '深色',
    en: 'Dark',
    ja: 'ダーク',
  },
  advanced: {
    zh: '高级',
    en: 'Advanced',
    ja: '詳細',
  },
  dataBackup: {
    zh: '数据备份',
    en: 'Data backup',
    ja: 'データバックアップ',
  },
  dataRecovery: {
    zh: '数据恢复',
    en: 'Data recovery',
    ja: 'データ復旧',
  },
  historyCleanup: {
    zh: '清除历史数据',
    en: 'Clear history data',
    ja: '履歴データをクリアする',
  },
  cleanHistoryDialogMessage: {
    zh: '即将删除所有连接中的历史消息记录、发送端记录的发布消息、主题、保留标志及历史连接配置。确定吗？',
    en: 'This will delete all historical message records in connections, messages published by the sender, topics, retain flags, and past connection configurations. Confirm?',
    ja: '接続内のすべての過去のメッセージ記録、送信者によって公開されたメッセージ、トピック、保持フラグ、および過去の接続設定を削除しようとしています。確認してください。',
  },
  autoResub: {
    zh: '自动恢复订阅',
    en: 'Auto resubscribe',
    ja: '自動的に再購読',
  },
  autoResubDesc: {
    zh: '重连时，对连接的订阅列表进行恢复订阅',
    en: 'When reconnecting, the subscription list of the connection will be automatically resubscribed',
    ja: '再接続時に、接続のサブスクリプションリストが自動的に再購読されます',
  },
  autoScroll: {
    zh: '自动滚动',
    en: 'Auto scroll',
    ja: '自動スクロール',
  },
  autoScrollDesc: {
    zh: '是否自动滚动消息列表',
    en: 'Whether to automatically scroll the list of messages',
    ja: 'メッセージリストを自動的にスクロールするかどうか',
  },
  autoScrollInterval: {
    zh: '自动滚动频率（秒）',
    en: 'Auto scroll interval (seconds)',
    ja: '自動スクロール間隔（秒）',
  },
  multiTopics: {
    zh: '多主题订阅',
    en: 'Multi topics subscribe',
    ja: '複数のトピックを購読',
  },
  multiTopicsDesc: {
    zh: '开启后，将支持一次订阅多个主题，使用逗号（,）分隔',
    en: 'Enable to subscribe to multiple topics at once, separated by commas',
    ja: '複数のトピックを一度に購読することができます。コンマで区切ります。',
  },
  topicWhitespaceDetection: {
    zh: '主题空格检测',
    en: 'Topic whitespace detection',
    ja: 'トピック空白検出',
  },
  topicWhitespaceDetectionDesc: {
    zh: '用于提示主题中的空格字符，帮助提前识别可能导致发布与订阅不匹配的情况。',
    en: 'Highlights whitespace in topics to help prevent publish/subscribe mismatches.',
    ja: 'トピック内の空白を示し、送受信の不一致を防ぐための確認に役立ちます。',
  },
}
